module.exports = __webpack_public_path__ + "static/media/galerija_2023 (9).5b022adf.jpg";